var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaskUnchecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TaskExpanded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Collapsed",
    transform: "translate(-18.000000, -14.000000)",
    fill: "#00BE7C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,14 C35.7614237,14 38,16.2385763 38,19 L38,29 C38,31.7614237 35.7614237,34 33,34 L23,34 C20.2385763,34 18,31.7614237 18,29 L18,19 C18,16.2385763 20.2385763,14 23,14 L33,14 Z M32.7222222,15.5 L23.2777778,15.5 C21.1913687,15.5 19.5,17.1913687 19.5,19.2777778 L19.5,19.2777778 L19.5,28.7222222 C19.5,30.8086313 21.1913687,32.5 23.2777778,32.5 L23.2777778,32.5 L32.7222222,32.5 C34.8086313,32.5 36.5,30.8086313 36.5,28.7222222 L36.5,28.7222222 L36.5,19.2777778 C36.5,17.1913687 34.8086313,15.5 32.7222222,15.5 L32.7222222,15.5 Z",
    id: "Combined-Shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskUnchecked);
export default __webpack_public_path__ + "static/media/task-unchecked.d8de31fce8279290006be47cc12d9c33.svg";
export { ForwardRef as ReactComponent };